//import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { IFilterSocieteBO, IFilterSocieteBODTO, dtoToFilter, filterToQuery,getDefaultFilterSociete } from "../../models/interfaces/IFilterSocieteBO";
import { ISorter } from "../../models/interfaces/ISorter";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import CpntDataTable from "../../components/dataTable/CpntDataTable";

import CpntPagination from "../../components/CpntPagination";
import SocietesFilter from "./components/SocietesFilter";
import { useFetchBOSocietesCompteQuery } from "../../redux/slice/api/BO/societeApi";
import { ISocieteCompte } from "../../models/interfaces/ISociete";
import HtmlRenderTypeCompteSociete from "../../components/HtmlRender/HtmlRenderTypeCompteSociete";
import HtmlRenderSecteurActiviteCompteSociete from "../../components/HtmlRender/HtmlRenderSecteurActiviteCompteSociete";
import SpinnerEditeurPro from "../FO/components/SpinnerEditeurPro";
import { useNavigate } from "react-router-dom";




const PageBOSocietes: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterSocieteBO>();
  const [searchParams, setSearchParams] = useState<IFilterSocieteBODTO|undefined>(undefined);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
 
  // //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();

  const navigate = useNavigate();

  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterSocietesBO");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterSociete());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterSociete()) {
      const _filter: IFilterSocieteBODTO = filterToQuery({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterSocietesBO",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { data: SocietesCompteResult, isFetching, error } = useFetchBOSocietesCompteQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined || (searchParams.Limit ?? 0) < 10,
  });

  

  useEffect(() => {
    setNumberOfResults(SocietesCompteResult?.Quantite ?? null);
  }, [SocietesCompteResult]);
  
  const applyFilter = (data: IFilterSocieteBO) => {
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { CompteSociete: "/admin/comptesociete/[[IdSociete]]"},
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
    {
      PathsName: { CompteUtilisateur: ""},
      State: { type_access: "" },
      ClassName: "bi-people fs-5 mb-2",
      ActionCallBack: (index) => {
        const societe = SocietesCompteResult?.Societes[index];
        
        if (societe && societe?.RaisonSociale) {
          localStorage.setItem("IFilterComptes",JSON.stringify({RaisonSociale:societe?.RaisonSociale}));
          navigate("/admin/societes/comptes");
          return false; //stop propagation
        } else {
          return true;
        }
      }
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "IdSociete",
      Name: "Id Societe",
      Class: "",
      sorter: (a: ISocieteCompte, b: ISocieteCompte) =>
        a.IdSociete - b?.IdSociete,
    },
    {
      Id: "RaisonSociale",
      Name: "Raison Sociale",
      Class: "",
      sorter: (a: ISocieteCompte, b: ISocieteCompte) =>
        a?.RaisonSociale?.localeCompare(b?.RaisonSociale),
    },
    {
      Id: "IdTypeCompteSociete",
      Name: "Type de Compte",
      Class: "",
      sorter: (a: ISocieteCompte, b: ISocieteCompte) =>
      (a?.IdTypeCompteSociete ? a?.IdTypeCompteSociete : -1) - (b?.IdTypeCompteSociete ? b?.IdTypeCompteSociete : -1),
    },
    {
      Id: "IdSecteurActivite",
      Name: "Secteur d'activité",
      Class: "",
      sorter: (a: ISocieteCompte, b: ISocieteCompte) =>
      (a?.IdSecteurActivite ? a?.IdSecteurActivite : -1) - (b?.IdSecteurActivite ? b?.IdSecteurActivite : -1),
    },
  ];


  const dataItemsStyle = {
    Id: "",
    RaisonSociale:"",
    IdTypeCompteSociete: <HtmlRenderTypeCompteSociete />,
    IdSecteurActivite: <HtmlRenderSecteurActiviteCompteSociete />
  };

  return (
    <>
     <div className="container text-start ">
      <div className="row pt-3 pb-2">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-buildings pe-2" />Gestion des comptes sociétés</h2>
        </div>
      </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <SocietesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            {/* Facettes */}
            </>
          )}
           
        </div> 
        <div className="row ">
          {numberOfResults !== null && SocietesCompteResult?.Societes && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
        
            </div>
          }
          {isFetching ? (
         <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            SocietesCompteResult?.Societes && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={SocietesCompteResult && SocietesCompteResult?.Societes ? [...SocietesCompteResult.Societes] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PagBOComptesSociete"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>);
};

export default PageBOSocietes;


